import React from 'react';
import PropTypes from 'prop-types';
import ModalContext from './context';

function withModalContext(Component) {
  return props => (
    <ModalContext.Consumer>
      {context => <Component {...props} {...context} />}
    </ModalContext.Consumer>
  );
}

withModalContext.propTypes = {
  Component: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.array,
    PropTypes.object
  ]).isRequired
};

export default withModalContext;
